import {ChangeDetectionStrategy, Component, Input} from "@angular/core";

@Component({
  selector: "n-control-group",
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ["./n-control-group.css"],
  template: `
    <div class="n-control-group" [class._inline]="inline" [class._top-align]="topAlign">
      <ng-content></ng-content>
    </div>`
})
export class NControlGroupComponent {
  @Input() inline: boolean;
  @Input() topAlign: boolean;
}
